import PropTypes from 'prop-types';
import React from 'react';
import TextSection from 'components/contentBlocks/TextSection';
import { cmsTextContentProp } from 'utils/proptypes/modules/textProps';
import transformTextSection from 'libs/wordpress/utils/transfromTextSection';

const TextBlock = ({ content, isColumn = false, isCustomerServiceCategory = false }) => (
    <TextSection
        customerServiceStyle={isCustomerServiceCategory}
        fullWidth={isColumn}
        textSections={transformTextSection(content)}
    />
);

TextBlock.propTypes = {
    content: cmsTextContentProp,
    isColumn: PropTypes.bool,
    isCustomerServiceCategory: PropTypes.bool,
};

export default TextBlock;
